import { useDataChainId } from '@ui/hooks/datachain';
import { TradePair } from '@ui/types/tradePair';

import { usePairMarketScheduleStore } from './usePairMarketScheduleStore/usePairMarketScheduleStore';

export const useIsPairClose = (pair: TradePair) => {
  const chainId = useDataChainId();

  return !usePairMarketScheduleStore((v) => {
    return v.getMarketScheduleByPair(pair.pairName, chainId)?.isClientOpen;
  });
};
